import { HubConnectionBuilder, HubConnection } from "@microsoft/signalr";
import { makeAutoObservable, runInAction } from "mobx";
import ApiStore from "./ApiStore";
import { HubConnectionState } from "@microsoft/signalr";
import { AuthorType, TicketMessage } from "../api/TicketApi";
import { message } from "antd";

class TicketChatStore {
  supportConnection: HubConnection | null = null;
  messages: TicketMessage[] = [];
  api: ApiStore;
  isLoading: boolean = false;
  text: string = "";
  fileList: File[] = [];

  setText = (text: string) => {
    this.text = text;
  }

  setFileList = (fileList: File[]) => {
    this.fileList = fileList;
  }

  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.api = apiStore;
  }

  connect(ticketId: string) {
    var baseUrl = this.api.CommonApiClient.BASE_URL;
    const connection = new HubConnectionBuilder()
      .withUrl(`${baseUrl}/ticketChatHub`, {
        accessTokenFactory: () => this.api.configApi.token,
      })
      .withAutomaticReconnect()
      .build();

    this.supportConnection = connection;

    runInAction(() => {
      this.api.TicketApi.getById(ticketId).then((res) => {
        this.messages = res.messages;
        this.isLoading = false;
      });
    });

    connection.on("Sync", () => {
      runInAction(() => {
        this.api.TicketApi.getById(ticketId).then((res) => {
          this.messages = res.messages;
          // Causes the message in the input field to disappear in the first seconds after input
          // this.isLoading = false;
          // this.fileList = [];
          // this.text = "";
        });
      });
    });

    this.supportConnection.on("ReceiveMessage", (message) => {
      runInAction(() => {
        this.api.TicketApi.getById(ticketId).then((res) => {
          this.messages = res.messages;
          // Causes the message in the input field to disappear in the first seconds after input
          // this.isLoading = false;
          // this.fileList = [];
          // this.text = "";
        });
      });
    });

    this.supportConnection
      .start()
      .then(() => this.supportConnection!.invoke("JoinTicket", ticketId))
      .catch(console.error);
  }

  addMessage = async (ticketId: string, text: string, username: string, email: string, role: string, authorType: AuthorType, fileList: File[]) => {
    try {
      this.isLoading = true;

      const formDataMessage = new FormData();
      formDataMessage.append('text', text);
      formDataMessage.append('username', username);
      formDataMessage.append('email', email);
      formDataMessage.append('role', role);
      formDataMessage.append('authorType', authorType.toString());

      fileList.forEach(file => {
        formDataMessage.append('files', file);
      });

      await this.api.TicketApi.addMessage(ticketId, formDataMessage);

      if (this.supportConnection?.state !== HubConnectionState.Connected) {
        await this.supportConnection?.start();
      }
      await this.supportConnection?.invoke("Sync", ticketId);
      runInAction(() => {
        this.text = "";
        this.fileList = [];
        this.isLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.isLoading = false;
      });

      message.error("Sync failed, please try again after reloading the page");
      console.error(error);
    }
    // false after signarR sync
  }

  addMessageFormData = async (ticketId: string, formDataMessage: FormData) => {
    try {
      formDataMessage.append('authorType', AuthorType.User.toString());

      this.isLoading = true;

      this.api.TicketApi.addMessage(ticketId, formDataMessage).then(() => {
        try {
          this.supportConnection?.invoke("Sync", ticketId);
        } catch (error) {
          message.error("Sync failed please try again after reload page");
        }
      });
      runInAction(() => {
        this.isLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.isLoading = false;
      });
      message.error("Error sending message, please try again");
      console.error("Error adding message:", error);
    }
  }

  sendMessage = async (ticketId: string, messageText: string, role: string, userName: string) => {
    if (!this.supportConnection) {
      console.error("No active connection");
      return;
    }

    if (this.supportConnection.state !== HubConnectionState.Connected) {
      try {
        console.warn("Reconnecting...");
        await this.supportConnection.start();
        await this.supportConnection.invoke("JoinTicket", ticketId);
      } catch (error) {
        console.error("Reconnection failed", error);
        return;
      }
    }

    try {
      await this.supportConnection.invoke("SendMessage", ticketId, messageText, role, userName);
    } catch (error) {
      console.error("SendMessage failed", error);
    }
  };

  disconnect(ticketId: string) {
    if (this.supportConnection) {
      // this.supportConnection.invoke("LeaveTicket", ticketId);
      this.supportConnection.stop();
    }
  }
}

export default TicketChatStore;
